'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass border-b border-border' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2.5">
          <AppLogo size={36} variant="icon" />
          <AppLogo size={75} variant="text" className="h-[75px]" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {[
            { label: 'Features', href: '#features' },
            { label: 'How It Works', href: '#how-it-works' },
            { label: 'For Artists', href: '#artists' },
            { label: 'Privacy', href: '#privacy' },
          ]?.map((item) => (
            <a
              key={`nav-link-${item?.label?.toLowerCase()?.replace(/\s/g, '-')}`}
              href={item?.href}
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-150"
            >
              {item?.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/sign-up-login-screen" className="btn-ghost text-sm">
            Log In
          </Link>
          <Link href="/sign-up-login-screen" className="btn-primary text-sm">
            Get Started Free
          </Link>
        </div>

        <button
          className="md:hidden btn-ghost p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle mobile menu"
        >
          <Icon name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} variant="outline" />
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden glass border-t border-border px-6 py-4 space-y-3 animate-fade-in">
          {['Features', 'How It Works', 'For Artists', 'Privacy']?.map((label) => (
            <a
              key={`mobile-nav-${label?.toLowerCase()?.replace(/\s/g, '-')}`}
              href={`#${label?.toLowerCase()?.replace(/\s/g, '-')}`}
              className="block py-2 text-sm font-medium text-muted-foreground hover:text-foreground"
              onClick={() => setMobileOpen(false)}
            >
              {label}
            </a>
          ))}
          <div className="pt-3 flex flex-col gap-2 border-t border-border">
            <Link href="/sign-up-login-screen" className="btn-secondary w-full justify-center">
              Log In
            </Link>
            <Link href="/sign-up-login-screen" className="btn-primary w-full justify-center">
              Get Started Free
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}